import {
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  TableRow,
  TableBody,
  Input,
} from "@windmill/react-ui";

import CommonPagination from "components/pagination/commonPagination";
import { useEffect, useState } from "react";
import GoogleCityAutoCompletion from "services/GoogleCityAutoCompletionServices";

const CityAutocompletion = () => {
  const [page, setPage] = useState(1);
  const [cities, setCities] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchAutoCompletionCities = async () => {
    try {
      setLoading(true);
      setError("");

      const response =
        await GoogleCityAutoCompletion.getAllGoogleCityAutocompletions({
          page,
        });

      const result = response?.data;

      if (result?.status === false) {
        throw new Error(result?.message || "Failed to fetch cities");
      }

      setCities(result?.data || []);
      setTotalRecords(Number(result?.totalRecords) || 0);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setError("Failed to load cities. Please try again.");
      setCities([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAutoCompletionCities();
  }, [page]);

  // Search within the currently loaded 50 records
  const filteredCities = cities.filter((item) =>
    item.city_name?.toLowerCase().includes(search.toLowerCase().trim()),
  );

  return (
    <div className="w-full mt-4">
      {/* Search */}
      <div className="flex items-center justify-between gap-3 mb-4">
        <Input
          className="border h-10 text-sm focus:outline-none block bg-gray-100 border-transparent focus:bg-white"
          type="search"
          name="search"
          placeholder="Search city..."
          autoComplete="off"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: "500px", maxWidth: "100%" }}
        />

        {/* <div className="text-sm text-gray-500 whitespace-nowrap">
          Total: {totalRecords}
        </div> */}
      </div>

      {/* Table */}
      <TableContainer className="mb-5">
        <div
          className="overflow-auto"
          style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
        >
          <Table>
            <TableHeader className="custom-table-header capitalize text-center sticky top-0 z-10 text-sm">
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Latitude</TableCell>
                <TableCell>Longitude</TableCell>
              </TableRow>
            </TableHeader>

            <TableBody className="text-center text-sm">
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4}>
                    <div className="py-6 text-gray-500">Loading cities...</div>
                  </TableCell>
                </TableRow>
              ) : error ? (
                <TableRow>
                  <TableCell colSpan={4}>
                    <div className="py-6 text-red-500">{error}</div>
                    <button
                      type="button"
                      onClick={fetchAutoCompletionCities}
                      className="text-blue-600 hover:underline"
                    >
                      Retry
                    </button>
                  </TableCell>
                </TableRow>
              ) : filteredCities.length > 0 ? (
                filteredCities.map((item, index) => (
                  <TableRow
                    key={`${item.city_name}-${item.latitude}-${item.longitude}-${index}`}
                  >
                    {/* <TableCell>{(page - 1) * 50 + index + 1}</TableCell> */}
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.city_name || "-"}</TableCell>
                    <TableCell>{item.latitude ?? "-"}</TableCell>
                    <TableCell>{item.longitude ?? "-"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    <div className="py-6 text-gray-500">
                      {search
                        ? "No matching cities found on this page."
                        : "No cities found."}
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        {/* Common Pagination */}
        {!loading && !error && (
          <CommonPagination
            page={page}
            limit={50}
            totalRecords={totalRecords}
            onPageChange={setPage}
          />
        )}
      </TableContainer>
    </div>
  );
};

export default CityAutocompletion;
